var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoPartnerKavir(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 257,
    height: 106,
    viewBox: "0 0 257 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M156.309 63.7932H148.059L139.082 49.3557L136.012 51.5588V63.7932H128.747V29.5276H136.012V45.2073L138.872 41.176L148.153 29.5276H156.215L144.262 44.6917L156.309 63.7932Z",
    fill: "#3A3A3A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M179.198 63.7932L176.714 55.637H164.222L161.737 63.7932H153.909L166.003 29.387H174.886L187.026 63.7932H179.198ZM174.979 49.5432C172.682 42.1526 171.386 37.9729 171.089 37.0042C170.807 36.0354 170.604 35.2698 170.479 34.7073C169.964 36.7073 168.487 41.6526 166.05 49.5432H174.979Z",
    fill: "#3A3A3A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M206.587 29.5276H213.923L202.275 63.7932H194.353L182.728 29.5276H190.064L196.509 49.9182C196.868 51.1213 197.236 52.5276 197.611 54.137C198.001 55.7307 198.243 56.8401 198.337 57.4651C198.509 56.0276 199.095 53.512 200.095 49.9182L206.587 29.5276Z",
    fill: "#3A3A3A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M215.859 63.7932V29.5276H223.125V63.7932H215.859Z",
    fill: "#3A3A3A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M236.615 44.7385H238.959C241.256 44.7385 242.951 44.3557 244.045 43.5901C245.139 42.8245 245.686 41.6213 245.686 39.9807C245.686 38.3557 245.123 37.1995 243.998 36.512C242.889 35.8245 241.162 35.4807 238.818 35.4807H236.615V44.7385ZM236.615 50.6448V63.7932H229.35V29.5276H239.334C243.99 29.5276 247.436 30.3792 249.67 32.0823C251.904 33.7698 253.022 36.3401 253.022 39.7932C253.022 41.8088 252.467 43.6057 251.357 45.1838C250.248 46.7463 248.678 47.9729 246.647 48.8635C251.803 56.5667 255.162 61.5432 256.725 63.7932H248.662L240.482 50.6448H236.615Z",
    fill: "#3A3A3A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M139.743 79.7014C139.743 80.7327 139.371 81.5452 138.626 82.1389C137.886 82.7327 136.855 83.0295 135.532 83.0295C134.313 83.0295 133.235 82.8004 132.298 82.342V80.092C133.069 80.4358 133.72 80.678 134.251 80.8186C134.787 80.9592 135.277 81.0295 135.72 81.0295C136.251 81.0295 136.657 80.928 136.938 80.7249C137.225 80.5217 137.368 80.2196 137.368 79.8186C137.368 79.5946 137.305 79.3967 137.18 79.2249C137.055 79.0478 136.871 78.8785 136.626 78.717C136.386 78.5556 135.894 78.2978 135.149 77.9436C134.451 77.6155 133.928 77.3004 133.579 76.9983C133.23 76.6962 132.951 76.3446 132.743 75.9436C132.535 75.5426 132.43 75.0738 132.43 74.5374C132.43 73.5269 132.772 72.7327 133.454 72.1545C134.141 71.5764 135.089 71.2874 136.298 71.2874C136.891 71.2874 137.457 71.3577 137.993 71.4983C138.535 71.6389 139.1 71.8368 139.688 72.092L138.907 73.9749C138.298 73.7249 137.792 73.5504 137.391 73.4514C136.996 73.3525 136.605 73.303 136.22 73.303C135.761 73.303 135.41 73.4097 135.165 73.6233C134.92 73.8368 134.798 74.1155 134.798 74.4592C134.798 74.6728 134.847 74.8603 134.946 75.0217C135.045 75.178 135.201 75.3316 135.415 75.4827C135.634 75.6285 136.147 75.8941 136.954 76.2795C138.022 76.79 138.753 77.303 139.149 77.8186C139.545 78.329 139.743 78.9566 139.743 79.7014Z",
    fill: "#3A3A3A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M145.42 82.8733H142.998V73.467H139.896V71.4514H148.521V73.467H145.42V82.8733Z",
    fill: "#3A3A3A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M156.057 82.8733H149.479V71.4514H156.057V73.4358H151.901V75.9436H155.768V77.928H151.901V80.8733H156.057V82.8733Z",
    fill: "#3A3A3A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M164.226 82.8733H157.648V71.4514H164.226V73.4358H160.07V75.9436H163.937V77.928H160.07V80.8733H164.226V82.8733Z",
    fill: "#3A3A3A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M165.816 82.8733V71.4514H168.238V80.8733H172.871V82.8733H165.816Z",
    fill: "#3A3A3A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M182.255 73.303C181.344 73.303 180.638 73.6467 180.138 74.3342C179.638 75.0165 179.388 75.9696 179.388 77.1936C179.388 79.7405 180.344 81.0139 182.255 81.0139C183.058 81.0139 184.029 80.8134 185.17 80.4124V82.4436C184.232 82.8342 183.185 83.0295 182.029 83.0295C180.367 83.0295 179.097 82.5269 178.216 81.5217C177.336 80.5113 176.896 79.0634 176.896 77.178C176.896 75.9905 177.112 74.9514 177.545 74.0608C177.977 73.165 178.597 72.4801 179.404 72.0061C180.216 71.5269 181.167 71.2874 182.255 71.2874C183.365 71.2874 184.479 71.5556 185.599 72.092L184.818 74.0608C184.391 73.8577 183.961 73.6806 183.529 73.5295C183.097 73.3785 182.672 73.303 182.255 73.303Z",
    fill: "#3A3A3A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M196.846 77.1467C196.846 79.0374 196.377 80.4905 195.44 81.5061C194.502 82.5217 193.159 83.0295 191.409 83.0295C189.659 83.0295 188.315 82.5217 187.377 81.5061C186.44 80.4905 185.971 79.0321 185.971 77.1311C185.971 75.2301 186.44 73.7795 187.377 72.7795C188.32 71.7743 189.669 71.2717 191.424 71.2717C193.179 71.2717 194.521 71.7769 195.448 72.7874C196.38 73.7978 196.846 75.2509 196.846 77.1467ZM188.51 77.1467C188.51 78.4228 188.752 79.3837 189.237 80.0295C189.721 80.6754 190.445 80.9983 191.409 80.9983C193.341 80.9983 194.307 79.7144 194.307 77.1467C194.307 74.5738 193.346 73.2874 191.424 73.2874C190.461 73.2874 189.734 73.6129 189.245 74.2639C188.755 74.9097 188.51 75.8707 188.51 77.1467Z",
    fill: "#3A3A3A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M203.249 82.8733L200.499 73.9124H200.429C200.528 75.7353 200.577 76.9514 200.577 77.5608V82.8733H198.413V71.4514H201.71L204.413 80.1858H204.46L207.327 71.4514H210.624V82.8733H208.366V77.467C208.366 77.2118 208.369 76.9176 208.374 76.5842C208.385 76.2509 208.421 75.3655 208.484 73.928H208.413L205.468 82.8733H203.249Z",
    fill: "#3A3A3A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M215.129 76.8264H215.926C216.671 76.8264 217.228 76.6806 217.598 76.3889C217.967 76.092 218.152 75.6624 218.152 75.0999C218.152 74.5321 217.996 74.1129 217.684 73.842C217.376 73.5712 216.892 73.4358 216.23 73.4358H215.129V76.8264ZM220.598 75.0139C220.598 76.2431 220.212 77.1832 219.441 77.8342C218.676 78.4853 217.585 78.8108 216.168 78.8108H215.129V82.8733H212.707V71.4514H216.355C217.741 71.4514 218.793 71.7509 219.512 72.3499C220.236 72.9436 220.598 73.8316 220.598 75.0139Z",
    fill: "#3A3A3A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M221.954 82.8733V71.4514H224.376V80.8733H229.009V82.8733H221.954Z",
    fill: "#3A3A3A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M236.779 82.8733H230.201V71.4514H236.779V73.4358H232.623V75.9436H236.49V77.928H232.623V80.8733H236.779V82.8733Z",
    fill: "#3A3A3A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M247.604 82.8733H244.838L242.182 78.553L239.526 82.8733H236.932L240.721 76.9827L237.174 71.4514H239.846L242.307 75.5608L244.721 71.4514H247.33L243.745 77.1155L247.604 82.8733Z",
    fill: "#3A3A3A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M0.563293 0.833253H84.5633V16.7933H0.563293V0.833253Z",
    fill: "url(#paint0_linear_943_5457)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5233 4.83325L16.5233 85.2612H0.563312L0.563315 4.83325L16.5233 4.83325Z",
    fill: "url(#paint1_linear_943_5457)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M106.205 105.833L0.563354 105.833L0.563353 89.8732L106.205 89.8732V105.833Z",
    fill: "url(#paint2_linear_943_5457)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2449 97.8332L90.2449 0.833253L106.205 0.833252V97.8332H90.2449Z",
    fill: "url(#paint3_linear_943_5457)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8431 53.3333C79.8431 67.9462 67.997 79.7923 53.3841 79.7923C38.7712 79.7923 26.925 67.9462 26.925 53.3333C26.925 38.7204 38.7712 26.8743 53.3841 26.8743C67.997 26.8743 79.8431 38.7204 79.8431 53.3333Z",
    fill: "url(#paint4_linear_943_5457)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_943_5457",
    x1: 5.23011,
    y1: 11.3472,
    x2: 97.9527,
    y2: 97.4467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF793E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458333,
    stopColor: "#FF9B3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF793E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_943_5457",
    x1: 5.23011,
    y1: 11.3472,
    x2: 97.9527,
    y2: 97.4467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF793E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458333,
    stopColor: "#FF9B3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF793E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_943_5457",
    x1: 5.23011,
    y1: 11.3472,
    x2: 97.9527,
    y2: 97.4467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF793E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458333,
    stopColor: "#FF9B3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF793E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_943_5457",
    x1: 5.23011,
    y1: 11.3472,
    x2: 97.9527,
    y2: 97.4467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF793E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458333,
    stopColor: "#FF9B3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF793E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_943_5457",
    x1: 5.23011,
    y1: 11.3472,
    x2: 97.9527,
    y2: 97.4467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF793E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458333,
    stopColor: "#FF9B3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF793E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPartnerKavir);
export default __webpack_public_path__ + "static/media/LogoPartner_Kavir.b021e27f5137c65cbff884b85bd16c0b.svg";
export { ForwardRef as ReactComponent };